import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogBoundryService } from '@secca/core/services/dialog-boundry.service';

export interface DocumentPreviewDialogData {
  base64ForDocument: string;
  extension: string;
  title: string;
}

@Component({
  selector: 'app-document-preview-dialog',
  templateUrl: './document-preview-dialog.component.html',
  styleUrls: ['./document-preview-dialog.component.scss'],
  standalone: false
})
export class DocumentPreviewDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<DocumentPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DocumentPreviewDialogData,
    public dialogBoundryService: DialogBoundryService
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
